import { render, staticRenderFns } from "./Entente.vue?vue&type=template&id=2bae32e3&scoped=true"
import script from "./Entente.vue?vue&type=script&lang=js"
export * from "./Entente.vue?vue&type=script&lang=js"
import style0 from "./Entente.vue?vue&type=style&index=0&id=2bae32e3&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae32e3",
  null
  
)

export default component.exports